export default {
  message: {
    Tour: {
      continue: "Continuer",
      back: "Retour",
      finish: "Terminer"
    },
    Login: {
      title: "Connexion des parents",
      sign_in: "Se connecter",
      login_fail:
        "Échec de l'authentification. Veuillez réessayer ou contacter l'école pour obtenir de l'aide.",
      forgot_password: "Mot de passe oublié",
      create_account: "Créer un compte",
      password: "Mot de passe",
      confirm_password: "Confirmer le mot de passe",
      password_reminder: "Rappel de mot de passe",
      enter_email: "Entrez votre adresse email",
      validation_error: "Erreur de validation",
      password_reminder_error_no_user_register:
        "Le nom d'utilisateur est introuvable. Veuillez réessayer ou créer un nouveau compte.",
      password_reminder_error_no_user: "Le nom d'utilisateur est introuvable.",
      password_reminder_sent: "Un email contenant des instructions a été envoyé à {email}.",
      password_reminder_sent_message:
        "L'email peut prendre quelques minutes à arriver. Vérifiez également votre dossier spam.",
      password_trouble_email: "Si vous avez encore des problèmes, contactez {email}.",
      password_trouble_school: "Si vous avez encore des problèmes, contactez votre école.",
      return_to_sign_in: "Retour à la connexion",
      create_my_account: "Créer mon compte",
      or_sign_in_with: "OU SE CONNECTER AVEC",
      password_reset: "Veuillez choisir un nouveau mot de passe.",
      password_reset_warning:
        "Si vous n'avez pas demandé à changer votre mot de passe, contactez immédiatement l'administrateur de l'école.",
      password_update: "Choisissez un nouveau mot de passe",
      password_update_confirm: "Confirmez le nouveau mot de passe",
      password_update_success: "Votre nouveau mot de passe a été enregistré."
    },
    AccountSettings: {
      title: "Paramètres du compte",
      first_name: "Prénom",
      last_name: "Nom",
      email: "Email",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      students: "Étudiants",
      teachers: "Enseignants",
      external_id: "ID externe",
      phone: "Numéro de téléphone",
      phone_required: "Le numéro de téléphone est obligatoire",
      edit: "Modifier",
      remove: "Supprimer",
      add: "Ajouter",
      remove_message: "Êtes-vous sûr de vouloir supprimer cet étudiant ?",
      yes: "Oui",
      no: "Non",
      add_student: "Ajouter un étudiant",
      close: "Fermer",
      save: "Enregistrer les modifications",
      cancel: "Annuler",
      student_alert_message: "Vous devez ajouter au moins un étudiant.",
      logout: "Se déconnecter"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "Mes réunions",
      language: "Français",
      help: "Aide",
      account_settings: "Paramètres du compte",
      user_management: "User Management",
      logout: "Se déconnecter"
    },
    SubNavbar: {
      meeting: "Réunion",
      event: "Événement",
      print: "Imprimer",
      email: "Email",
      export: "Exporter"
    },
    ConferenceCard: {
      add_edit_meetings: "Ajouter/Modifier des réunions",
      opening: "Ouverture",
      closed: "Fermé"
    },
    Agenda: {
      full_agenda: "Agenda complet",
      empty_state_title: "Aucune conférence trouvée.",
      empty_state_message: "Pour toute question, veuillez contacter votre école.",
      confirmation_modal_title: "Agenda Confirmé",
      confirmation_modal_message:
        "Votre agenda a été confirmé avec succès et un email vous a été envoyé.",
      complete_button: "Terminé !"
    },
    AgendaCard: {
      room: "Salle non disponible",
      room_with_value: "Salle : {room}",
      virtual_meeting: "Réunion virtuelle",
      all_conferences: "Toutes les conférences",
      conference: "Conférence",
      student: "Étudiant",
      meeting_with: "Réunion avec",
      date_time: "Date/Heure",
      meeting_type: "Type de réunion",
      location: "Emplacement",
      comment: "Commentaire",
      action: "Action",
      delete: "Supprimer",
      add_comment: "Ajouter un commentaire",
      join: "Rejoindre la réunion",
      choose_meeting_type: "Choisissez le type de réunion",
      in_person: "En présentiel",
      phone: "Téléphone",
      callback: "Rappel",
      virtual: "Virtuelle",
      hybrid: "Hybride",
      unavailable: "Indisponible",
      tooltip_translator:
        "Le service d'interprétation n'est pas garanti, mais l'école fera tout son possible pour qu'il soit disponible.",
      translator_requested: "Interprète {language} demandé",
      clear_translator: "Effacer la demande d'interprète",
      need_translator: "Besoin d'un interprète ?",
      choose_language: "Choisissez une langue"
    },
    ScheduleMatrix: {
      no_teachers_title: "Aucun enseignant ou équipe sélectionné.",
      no_teachers_message: "Veuillez choisir un enseignant pour voir les horaires.",
      choose_teachers_button: "Voir les enseignants ou équipes disponibles",
      choose_student: "Pour quel étudiant ?",
      cancel: "Annuler"
    },
    Matrix: {
      teachers: "Enseignants",
      agenda: "Revoir et continuer"
    },
    DrawerTeachers: {
      teachers: "Enseignants",
      name: "Nom",
      description: "Description",
      student: "Étudiant",
      teacher_team: "Enseignant/Équipe",
      show_more: "Afficher plus d'enseignants",
      show_all: "Afficher tous les enseignants de l'école",
      selected: "({count}) sélectionné(s)",
      closeDrawer: "Continuer vers le planning",
      search: "Rechercher un enseignant ou une équipe",
      not_available: "Cet enseignant n'a aucun créneau de réunion disponible le {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Aucune réunion planifiée.",
      no_meetings_message: "Après avoir choisi un enseignant et un créneau, cela s'affichera ici.",
      new_meeting_label: "Nouveau",
      cancel_button: "Annuler",
      student_label: "Étudiant",
      meeting_type_location: "Type/Emplacement de la réunion",
      comment_label: "Commentaire",
      save_comment_button: "Enregistrer le commentaire",
      confirm_label: "Veuillez confirmer :",
      confirm_cancel_button: "Oui, annuler ma réunion avec ",
      do_not_cancel_button: "Ne pas annuler",
      confirm_agenda_button: "Confirmer cet agenda",
      confirm_agenda_message_line1: "Vous pouvez revenir et modifier plus tard.",
      confirm_agenda_message_line2: "Votre agenda sera envoyé par email."
    },
    EmailConsent: {
      message:
        "Pour protéger votre vie privée, nous avons besoin de votre consentement pour envoyer des communications à votre adresse email.",
      consent: "Donner son consentement"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
